module.exports = __webpack_public_path__ + "static/the-myth-of-the-strong-leader-c518dc27d654cbfafed503c3cd024ae5.jpg";